import { Injectable } from '@angular/core';

//#region Internal

export enum LogLevel {
  Off = 0,
  Error = 1,
  Warning = 2,
  Info = 3,
  Debug = 4
}

export type LogOutput = (source: string, level: LogLevel, ...objects: any[]) => void;

//#endregion

@Injectable({ providedIn: 'root' })
export class LoggerService {
  static level = LogLevel.Debug;
  static outputs: LogOutput[] = [];

  static enableProductionMode(): void {
    LoggerService.level = LogLevel.Warning;
  }

  debug(...objects: any[]) {
    this.log(console.log, LogLevel.Debug, objects);
  }

  info(...objects: any[]) {
    this.log(console.info, LogLevel.Info, objects);
  }

  warn(...objects: any[]) {
    this.log(console.warn, LogLevel.Warning, objects);
  }

  error(...objects: any[]) {
    this.log(console.error, LogLevel.Error, objects);
  }

  private log(func: (...params: any[]) => any, level: LogLevel, objects: any[]) {
    if (level <= LoggerService.level) {
      func.apply(console, objects);

      LoggerService.outputs.forEach((output) =>
        output.apply(output, [level].concat(objects)));
    }
  }
}
